<form class="advanced-options" [formGroup]="filtersForm" (ngSubmit)="setCombinedValues()">
    @if (ShowSearchesFilters) {
        <div class="filter-group">
            <h4>{{ 'Searches' | localize }} ({{ loadedCategoryResultsCounts['searches'] }})</h4>
            <div class="checkbox-option">
                <p-checkbox
                    formControlName="ExternalAgency"
                    value="externalAgency"
                    [binary]="true"
                    class="p-checkbox-label"
                    label="{{ 'ExternalAgency' | localize }}"
                    (onChange)="onCheck()"
                 inputId="cb-ExternalAgency"></p-checkbox>
            </div>
            <div class="checkbox-option" (click)="toggleDepositFilterOption()">
                <p-checkbox
                    formControlName="Deposit"
                    value="Deposit"
                    [binary]="true"
                    class="p-checkbox-label"
                    label="{{ 'Deposit' | localize }}"
                    (onChange)="onCheck()"
                 inputId="cb-Deposit"></p-checkbox>
            </div>
            @if (filtersOptionsOpenState.isDepositVisible) {
                <div class="checkbox-option-panel">
                    <p-selectButton
                        [unselectable]="true"
                        class="custom-select-button"
                        [options]="stateOptions"
                        formControlName="depositValue"
                        optionLabel="label"
                        optionValue="value"
                    />
                </div>
            }
            <div class="checkbox-option">
                <p-checkbox
                    formControlName="InterestInProjects"
                    value="InterestInProjects"
                    [binary]="true"
                    class="p-checkbox-label"
                    label="{{ 'InterestInProjects' | localize }}"
                    (onChange)="onCheck()"
                 inputId="cb-InterestInProjects"></p-checkbox>
            </div>
            <div>
                <div class="checkbox-option">
                    <p-checkbox
                        formControlName="InterestInOffers"
                        value="InterestInOffers"
                        [binary]="true"
                        class="p-checkbox-label"
                        label="{{ 'InterestInOffers' | localize }}"
                        (onChange)="onCheck()"
                     inputId="cb-InterestInOffers"></p-checkbox>
                </div>
            </div>
            <div class="checkbox-option">
                <p-checkbox
                    formControlName="Condition"
                    value="Condition"
                    [binary]="true"
                    class="p-checkbox-label"
                    label="{{ 'Conditions' | localize }}"
                    (onChange)="onCheck()"
                 inputId="cb-Condition"></p-checkbox>
            </div>
            <div class="checkbox-option">
                <p-checkbox
                    formControlName="Furnishing"
                    value="Furnishing"
                    [binary]="true"
                    class="p-checkbox-label"
                    label="{{ 'FurnitureId' | localize }}"
                    (onChange)="onCheck()"
                 inputId="cb-Furnishing"></p-checkbox>
            </div>
            <div class="checkbox-option" (click)="toggleBedroomsFilterOption()">
                <p-checkbox
                    formControlName="Number of Bedrooms"
                    value="Number of Bedrooms"
                    [binary]="true"
                    class="p-checkbox-label"
                    label="{{ 'BedroomsRange' | localize }}"
                    (onChange)="onCheck()"
                 inputId="cb-Number-of-Bedrooms"></p-checkbox>
            </div>
            @if (filtersOptionsOpenState.isBedroomsVisible) {
                <div class="checkbox-option-panel">
                    <app-cma-range-input
                        [resetFlag]="resetFlag"
                        class="filter-container-group"
                        type="bedrooms"
                        [stepInput]="1"
                        [valueMin]="0"
                        [valueMax]="30"
                    ></app-cma-range-input>
                </div>
            }
            <div class="checkbox-option" (click)="toggleBathroomsFilterOption()">
                <p-checkbox
                    formControlName="Number of Bathrooms"
                    value="Number of Bathrooms"
                    [binary]="true"
                    class="p-checkbox-label"
                    label="{{ 'BathroomsRange' | localize }}"
                    (onChange)="onCheck()"
                 inputId="cb-Number-of-Bathrooms"></p-checkbox>
            </div>
            @if (filtersOptionsOpenState.isBathroomsVisible) {
                <div class="checkbox-option-panel">
                    <app-cma-range-input
                        [resetFlag]="resetFlag"
                        class="filter-container-group"
                        type="bathrooms"
                        [stepInput]="1"
                        [valueMin]="0"
                        [valueMax]="30"
                    ></app-cma-range-input>
                </div>
            }
            <div class="checkbox-option" (click)="togglePremisesFilterOption()">
                <p-checkbox
                    formControlName="Premises"
                    value="Premises"
                    [binary]="true"
                    class="p-checkbox-label"
                    label="{{ 'RoomsRange' | localize }}"
                    (onChange)="onCheck()"
                 inputId="cb-Premises"></p-checkbox>
            </div>
            @if (filtersOptionsOpenState.isPremisesVisible) {
                <div class="checkbox-option-panel">
                    <app-cma-range-input
                        [resetFlag]="resetFlag"
                        class="filter-container-group"
                        type="premises"
                        [stepInput]="1"
                        [valueMin]="0"
                        [valueMax]="30"
                    ></app-cma-range-input>
                </div>
            }
        </div>
    }
    <div class="filter-group">
        <h4>{{ 'Characteristics' | localize }} ({{ loadedCategoryResultsCounts['characteristics'] }})</h4>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Elevator"
                value="Elevator"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'Lift' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Elevator"></p-checkbox>
        </div>
        @if (isEstateCategorySelected(6)) {
            <div class="checkbox-option">
                <p-checkbox
                    formControlName="Heating"
                    value="Heating"
                    [binary]="true"
                    class="p-checkbox-label"
                    label="{{ 'HeatingId' | localize }}"
                    (onChange)="onCheck()"
                 inputId="cb-Heating"></p-checkbox>
            </div>
        }
        @if (isEstateCategorySelected(6)) {
            <div class="checkbox-option">
                <p-checkbox
                    formControlName="Parking"
                    value="Parking"
                    [binary]="true"
                    class="p-checkbox-label"
                    label="{{ 'Parking' | localize }}"
                    (onChange)="onCheck()"
                 inputId="cb-Parking"></p-checkbox>
            </div>
        }

        @if (isIndividual) {
            <div>
                <div class="checkbox-option">
                    <p-checkbox
                        formControlName="ExternalBroker"
                        value="ExternalBroker"
                        [binary]="true"
                        class="p-checkbox-label"
                        label="{{ 'ExternalBroker' | localize }}"
                        (onChange)="onCheck()"
                     inputId="cb-ExternalBroker"></p-checkbox>
                </div>
            </div>
        }

        <div class="checkbox-option">
            <p-checkbox
                formControlName="Condition"
                value="Condition"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'Conditions' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Condition"></p-checkbox>
        </div>
        @if (isEstateCategorySelected(6)) {
            <div class="checkbox-option">
                <p-checkbox
                    formControlName="Exposure"
                    value="Exposure"
                    [binary]="true"
                    class="p-checkbox-label"
                    label="{{ 'Exposure' | localize }}"
                    (onChange)="onCheck()"
                 inputId="cb-Exposure"></p-checkbox>
            </div>
        }
    </div>
    <div class="filter-group">
        <h4>{{ 'Advantages' | localize }} ({{ loadedCategoryResultsCounts['advantages'] }})</h4>

        <div class="checkbox-option" (click)="toggleComplexFilterOption()">
            <p-checkbox
                formControlName="GatedComplex"
                value="GatedComplex"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'ClosedComplex' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-GatedComplex"></p-checkbox>
        </div>
        @if (filtersOptionsOpenState.isComplexVisible) {
            <div class="checkbox-option-panel">
                <p-selectButton
                    [unselectable]="true"
                    class="custom-select-button"
                    [options]="stateOptions"
                    formControlName="value"
                    optionLabel="label"
                    optionValue="value"
                />
            </div>
        }

        @if (isEstateCategorySelected(8)) {
            <div class="checkbox-option">
                <p-checkbox
                    formControlName="Yard"
                    value="Yard"
                    [binary]="true"
                    class="p-checkbox-label"
                    label="{{ 'HasGarden' | localize }}"
                    (onChange)="onCheck()"
                 inputId="cb-Yard"></p-checkbox>
            </div>
        }
        @if (isEstateCategorySelected(8)) {
            <div class="checkbox-option">
                <p-checkbox
                    formControlName="Fitness"
                    value="Fitness"
                    [binary]="true"
                    class="p-checkbox-label"
                    label="{{ 'HasFitness' | localize }}"
                    (onChange)="onCheck()"
                 inputId="cb-Fitness"></p-checkbox>
            </div>
        }
        <div class="checkbox-option">
            <p-checkbox
                formControlName="View"
                value="View"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'HasView' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-View"></p-checkbox>
        </div>

        <div class="checkbox-option" (click)="togglePoolFilterOption()">
            <p-checkbox
                formControlName="Pool"
                value="Pool"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'Pool' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Pool"></p-checkbox>
        </div>
        @if (filtersOptionsOpenState.isPoolVisible) {
            <div class="checkbox-option-panel">
                <p-selectButton
                    [unselectable]="true"
                    class="custom-select-button"
                    [options]="stateOptions"
                    formControlName="poolValue"
                    optionLabel="label"
                    optionValue="value"
                />
            </div>
        }
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Security"
                value="Security"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'SecurityGuard' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Security"></p-checkbox>
        </div>
    </div>
    <div class="filter-group">
        <h4>{{ 'Estates' | localize }} ({{ loadedCategoryResultsCounts['estates'] }})</h4>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Project"
                value="Project"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'Project' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Project"></p-checkbox>
        </div>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Construction Type"
                value="Construction Type"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'ConstructionType' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Construction-Type"></p-checkbox>
        </div>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Stage of Completion"
                value="Stage of Completion"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'CompletionStage' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Stage-of-Completion"></p-checkbox>
        </div>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Year of Construction"
                value="Year of Construction"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'YearOfConstruction' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Year-of-Construction"></p-checkbox>
        </div>
        <div class="checkbox-option" (click)="toggleFloorsFilterOption()">
            <p-checkbox
                formControlName="Number of Floors"
                value="Number of Floors"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'PublicationDate' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Number-of-Floors"></p-checkbox>
        </div>
        @if (filtersOptionsOpenState.isFloorsVisible) {
            <div class="checkbox-option-panel">
                <app-cma-range-input
                    [resetFlag]="resetFlag"
                    class="filter-container-group"
                    type="floor"
                    [stepInput]="1"
                    [valueMin]="0"
                    [valueMax]="30"
                ></app-cma-range-input>
            </div>
        }
    </div>
    <div class="filter-group">
        <h4>{{ 'Details' | localize }} ({{ loadedCategoryResultsCounts['details'] }})</h4>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Publication Date"
                value="Publication Date"
                [binary]="true"
                class="p-checkbox-label"
                label="Дата на публикуване"
                (onChange)="onCheck()"
             inputId="cb-Publication-Date"></p-checkbox>
        </div>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Agency"
                value="Agency"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'Agency' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Agency"></p-checkbox>
        </div>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Consultant"
                value="Consultant"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'Consultant' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Consultant"></p-checkbox>
        </div>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Visible on Site"
                value="Visible on Site"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'VisibleOnSite' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Visible-on-Site"></p-checkbox>
        </div>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Published"
                value="Published"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'PublishedInImotBG' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Published"></p-checkbox>
        </div>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Transferred from"
                value="Transferred from"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'TransferredFrom' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Transferred-from"></p-checkbox>
        </div>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Source"
                value="Source"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'Source' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Source"></p-checkbox>
        </div>
    </div>
    <div class="filter-group">
        <h4>{{ 'Advertisement' | localize }} ({{ loadedCategoryResultsCounts['advertisement'] }})</h4>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Offer Status"
                value="Offer Status"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'OfferStatus' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Offer-Status"></p-checkbox>
        </div>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Documents"
                value="Documents"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'Documents' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Documents"></p-checkbox>
        </div>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Reference"
                value="Reference"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'ReportFile' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Reference"></p-checkbox>
        </div>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Confidential"
                value="Confidential"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'IsConfidential' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Confidential"></p-checkbox>
        </div>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Key"
                value="Key"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'Key' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Key"></p-checkbox>
        </div>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Inspections"
                value="Inspections"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'Viewings' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Inspections"></p-checkbox>
        </div>
        <div class="checkbox-option">
            <p-checkbox
                formControlName="Photos"
                value="Photos"
                [binary]="true"
                class="p-checkbox-label"
                label="{{ 'Images' | localize }}"
                (onChange)="onCheck()"
             inputId="cb-Photos"></p-checkbox>
        </div>
    </div>
    <div (click)="clearValues()" class="clear-all-values">
        {{ 'Clear' | localize }}
        <span class="pi pi-times"></span>
    </div>
    <button type="submit">Submit</button>
</form>
